import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { portalApi } from "@/lib/api";

const Ctx = createContext(null);
export const usePortal = () => useContext(Ctx);
const CART_KEY = "td_portal_cart";   // cart lines only; the session is an httpOnly cookie

export function PortalProvider({ children }) {
  const [me, setMe] = useState(null);
  const [ready, setReady] = useState(false);
  const [cart, setCart] = useState(() => { try { return JSON.parse(localStorage.getItem(CART_KEY) || "[]"); } catch { return []; } });

  const refresh = useCallback(() => portalApi.get("/portal/me").then(({ data }) => setMe(data)), []);
  useEffect(() => { refresh().catch((e) => { if (e?.response?.status !== 401) console.error("Portal session check failed", e); }).finally(() => setReady(true)); }, [refresh]);
  useEffect(() => { localStorage.setItem(CART_KEY, JSON.stringify(cart)); }, [cart]);

  const value = useMemo(() => ({
    me, ready, refresh, cart,
    login: async () => { await refresh(); },
    logout: async () => {
      try { await portalApi.post("/portal/auth/logout"); } catch { /* already logged out */ }
      localStorage.removeItem(CART_KEY); setMe(null); window.location.href = "/portal/login";
    },
    switchAccount: async (tenant_id) => { await portalApi.post("/portal/auth/switch", { tenant_id }); setCart([]); window.location.reload(); },
    addToCart: (p, qty = 1) => setCart((c) => {
      const i = c.findIndex((l) => l.product_id === p.id);
      if (i >= 0) return c.map((l, j) => (j === i ? { ...l, quantity: l.quantity + qty } : l));
      return [...c, { product_id: p.id, code: p.code, name: p.name, unit: p.unit, book_price: p.book_price, image_url: p.image_url, quantity: qty }];
    }),
    setQty: (product_id, quantity) => setCart((c) => (quantity <= 0 ? c.filter((l) => l.product_id !== product_id) : c.map((l) => (l.product_id === product_id ? { ...l, quantity } : l)))),
    clearCart: () => setCart([]),
  }), [me, ready, refresh, cart]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}
